export enum RolesEnum {
    DETAIL = 'jobs:view-detail',
    METADATA = 'jobs:view-metadata',
}
